<template>
  <el-col
    :span="24"
    id="countries"
    v-loading.body="(receiving || changingPage) && !navigating"
    element-loading-text="Fetching page...">
    <el-row type="flex">
      <el-col :span="24">
        <el-row type="flex" justify="start" align="middle" id="countries-header">
          <HeaderInfoText :colspan="9" title="COUNTRIES" :meta="meta" :selection="selection" />
          <el-col :span="6">
            <el-row type="flex" justify="center" v-if="meta.count > 20">
              <el-pagination
                layout="prev, pager, next, jumper"
                :total="meta.count"
                :page-size="20"
                @current-change="(page) => changePage({ page }, false)"
                v-model:current-page="currentPage">
              </el-pagination>
            </el-row>
          </el-col>
          <el-col :span="9" class="h-padded right-aligned-col">
            <el-select
              :disabled="!(selection && selection.length)"
              v-model="batchUpdateSelection"
              placeholder="With selected..."
              style="padding: 0 6px;"
              @change="handleBatchUpdateSelection">
              <el-option
                v-for="option in batchUpdateOptions"
                :key="option.id"
                :label="option.text"
                :value="option.id">
              </el-option>
            </el-select>
            <el-button type="primary" icon="plus" @click="createNewModel" />
          </el-col>
        </el-row>
        <el-row type="flex" justify="end" align="middle">
          <el-col :span="24">
            <el-table
              v-if="meta.count && !changingPage"
              id="countries-table"
              :ref="`${endpoint}Table`"
              :data="data"
              border
              style="width: 100%; z-index: 0;"
              :maxHeight="tableHeight"
              @select="handleSelectionChange"
              @select-all="handleSelectionChange">
              <el-table-column type="selection" width="55" align="center" />
              <el-table-column prop="name" label="Country" align="left" fit>
                <template v-slot="scope">
                  <el-row type="flex">
                    <a class="link-mock" @click="editExistingModel(scope.row.id)">
                      {{ scope.row.name }}
                    </a>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :title="editMode.active ? `Edit Country` : 'Create New Country'"
      width="45%"
      v-model="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false">
      <NewEntityForm
        :modalOpen="dialogFormVisible"
        :fields="fields"
        v-model:form="form"
        :idPrefix="'a-'"
        ref="form"
        @formChanged="handleFormChange"
      />
      <template v-slot:footer><span class="dialog-footer">
        <el-button :disabled="saving || !!updating" @click="closeFormModal">Cancel</el-button>
        <el-button :loading="saving || !!updating" type="primary" @click="submitForm">Submit</el-button>
      </span></template>
    </el-dialog>
  </el-col>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { payload } from '@/components/RouteComponents/Countries/actionPayload'
  import store from '@/store/store'
  import NewEntityForm from '@/components/NewEntityForm.vue'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import {
    handleBatchUpdateSelection,
    handleSelectionChange,
    createNewModel
  } from '@/components/RouteComponents/commonFunctions'
  import { systemViewMixins } from '@/Mixins/SystemViewMixins'

  export default {
    components: {
      NewEntityForm,
      HeaderInfoText
    },
    mixins: [ systemViewMixins ],
    data () {
      return {
        tableHeight: 1000,
        batchUpdateOptions: [
          { id: 0, text: 'Delete selected' }
        ],
        batchUpdateSelection: null,
        selection: [],
        dialogFormVisible: false,
        editMode: { active: false, modelId: null },
        changingPage: false
      }
    },
    methods: {
      /**
       * Handles what happens when the user clicks on one of the "With selected..." dropdown options
       */
      handleBatchUpdateSelection () {
        handleBatchUpdateSelection(this, payload)
      },
      /**
       * Handles transaction selection
       * @param selection
       */
      handleSelectionChange (selection) {
        handleSelectionChange(this, selection)
      },
      /**
       * Resets editMode data, resets form to initial state, and displays the
       * modal to create a new model
       */
      createNewModel () {
        createNewModel(this)
      },
      handleFormChange () {
        this.trackFormChange()
      }
    },
    computed: {
      ...mapGetters({
        data: 'getCountries'
      })
    },
    /**
     * Pre-route enter logic.
     * @param to
     * @param from
     * @param next
     */
    beforeRouteEnter (to, from, next) {
      let initPromises = [store.dispatch('clearLocalState', { clearMutation: payload.clearMutation, clearCache: true })]
      const fieldsAlreadyExist = !typeof store.getters.getResourceFieldsByEndpoint(payload.endpoint) === 'undefined'
      if (!fieldsAlreadyExist) {
        initPromises.push(store.dispatch('fetchOptions', payload))
      }
      Promise.all(initPromises)
        .then(() => store.dispatch('fetch', payload))
        .then(entities => store.dispatch('findDependencies', entities))
        .then(promises => Promise.all(promises))
        .then(() => next())
        .catch(e => console.log(e))
    },
    created () {
      this.endpoint = payload.endpoint
      this.moduleName = payload.moduleName
      this.payload = payload
      this.generateForm()
    },
    mounted () {
      this.$nextTick = () => {
        const tableHeight = () => {
          const parentHeight = document.getElementById('countries').offsetHeight
          const headerHeight = document.getElementById('countries-header').offsetHeight
          return parentHeight - headerHeight
        }
        this.tableHeight = tableHeight()
      }
    }
  }
</script>

<style scoped>
  #countries-header {
    border-bottom: 1px solid lightgray;
  }
  .h-padded {
    padding: 0 12px;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
</style>
